import * as API from 'common/constant/routes'
import { getJson, postJson, putFile } from 'helper/http'
import toSnakeCase from '@deliverance-ai/map-keys-case/to-snake-case'

export const getWebpages = (sort, direction, limit, start) => getJson(API.GET_WEBPAGES, {}, toSnakeCase({ direction, limit, sort, start }))
export const addNewWebpage = (webpageObject) => postJson(API.ADD_WEBPAGE, {}, { ...webpageObject })
export const editWebpage = (webpageObject) => postJson(API.EDIT_WEBPAGE, {}, { ...webpageObject })
export const uploadFile = (url, file) => putFile(url, file, file.type)
export const searchWebpages = (searchTerm, sort, direction, limit, start) => getJson(API.SEARCH_WEBPAGES, {}, toSnakeCase({ direction, limit, searchTerm, sort, start }))
export const downloadWebpages = (columns) => postJson(API.DOWNLOAD_WEBPAGES, {}, { columns })
